import BasicFooter from "components/Footer/BasicFooter";


export default BasicFooter;